<template>
    <div>
        <PullContainer
            ref="pullContainerRef"
            :pullDownLoading="true"
            :pullDownLabel="true"
            @pullDownLoadingSuccess="pullDownLoadingSuccess"
        >
            <template #container>
                <div class="public_container">
                    <div class="returnNavBar">
                        <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"></ReturnNavBar>
                        <div class="mobile_head_operate">
                            <p @click="handleClickAddWorkOrder"><i class="el-icon-plus"></i> 新建工单</p>
                        </div>
                    </div>
                    <div class="mobile_search">
                        <van-search
                            v-model="searchForm.keyword"
                            placeholder="请输入查询内容"
                            @clear="onSearch"
                            @search="onSearch"
                        >
                            <template #right-icon>
                                <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                            </template>
                        </van-search>
                    </div>
                    <div class="all_menu_list">
                        <ul>
                            <li
                                v-for="item in workOrderTypeList"
                                :key="item.value"
                                :class="{ active: workOrderType == item.value }"
                                @click="handleClickTypeChange(item)"
                            >
                                <span>{{ item.label }}</span>
                                <i class="count" v-if="item.total">{{ item.total > 99 ? "99+" : item.total }}</i>
                            </li>
                        </ul>
                    </div>
                    <div class="work_order_container mobile_container">
                        <div class="mobile_container_list">
                            <ul v-infinite-scroll="onLoadList">
                                <li v-for="(row, index) in workOrderTableList" :key="index" class="list_item">
                                    <div class="list_item_top">
                                        <span class="link-label" @click="handleClickWorkOrderDetail(row)">{{
                                            row.workorder_num
                                        }}</span>
                                        <span class="work_order_status" :class="'work_order_status' + row.status">{{
                                            row.status_text
                                        }}</span>
                                        <span class="handle" @click="handleClickItem(row)" v-if="row.status !== 7">
                                            <i class="iconfont icon-gengduo"></i>
                                        </span>
                                    </div>
                                    <div class="list_item_content">
                                        <div class="list_field_item">
                                            <span>工单类型：</span>
                                            <span class="field_value">{{
                                                row.workorder_type_id && row.workorder_type_id.text
                                            }}</span>
                                        </div>
                                        <div class="list_field_item">
                                            <span>发起人：</span>
                                            <div
                                                class="mobile_list_head_user"
                                                v-if="row.user.id"
                                                @click="handleClickUserInfo(row.user)"
                                            >
                                                <img :src="row.user.avatar ? row.user.avatar : defaultImg" alt="" />
                                                <span class="ellipsis" v-text="row.user.name"></span>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>

                    <ListAdvancedFiltering
                        v-if="searchPopupShow"
                        ref="listAdvancedFiltering"
                        :field_form="'workorders'"
                        :system_fields="systemFilterFields"
                        @sendFilterData="getFilterData"
                    />

                    <userDetailDialog
                        v-if="userDetailPopupShow"
                        :userDetailPopupShow.sync="userDetailPopupShow"
                        :userId="userDetailId"
                    />

                    <van-overlay
                        :custom-style="{ background: 'rgba(0, 0, 0, 0.3)' }"
                        z-index="1000"
                        v-if="handleRadioPicker"
                        :show="handleRadioPicker"
                        @click="handleRadioPicker = false"
                    >
                        <div class="custome_radio_option_wrap">
                            <!-- 工单状态：0=>审批中，1=>待指派，2=>待出发，3=>待实施，4=>实施中，5=>实施完成，6=>已结单，7=>已评价,-1=>已拒绝，-2=>已撤销，-3=>已关闭 -->
                            <!-- 实施人状态：0=>未出发，1=>待实施, 2=>实施中, 3=>实施完成 -->
                            <ul class="radio_option_list">
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status == -1 || activeItem.status == -2) &&
                                        activeItem.uid === owner_uid
                                    "
                                    @click="handleClickDelWorkOrder(activeItem)"
                                >
                                    删除
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="activeItem.status === 0 && activeItem.uid === owner_uid"
                                    @click="handleClickRevokeWorkOrder(activeItem)"
                                >
                                    撤销
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status === 1 ||
                                            activeItem.status === 2 ||
                                            activeItem.status === 3 ||
                                            activeItem.status === 4 ||
                                            activeItem.status === 5) &&
                                        activeItem.uid === owner_uid
                                    "
                                    @click="handleClickCloseWorkOrder(activeItem)"
                                >
                                    关闭工单
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status == -1 ||
                                            activeItem.status == -2 ||
                                            activeItem.status == -3) &&
                                        activeItem.uid === owner_uid
                                    "
                                    @click="handleClickRestartWorkOrder(activeItem)"
                                >
                                    再次发起
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status === 1 ||
                                            activeItem.status === 2 ||
                                            activeItem.status === 3 ||
                                            activeItem.status === 4 ||
                                            activeItem.status === 5) &&
                                        activeItem.is_assign_user
                                    "
                                    @click="handleClickDistributeWorkOrder(activeItem)"
                                >
                                    分配实施人员
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status === 2 ||
                                            activeItem.status === 3 ||
                                            activeItem.status === 4) &&
                                        activeItem.is_assign_user
                                    "
                                    @click="handleClickReplaceWorkOrder(activeItem)"
                                >
                                    替换实施人员
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status === 2 ||
                                            activeItem.status === 3 ||
                                            activeItem.status === 4) &&
                                        activeItem.is_assign_user
                                    "
                                    @click="handleClickRevokeDistributeWorkOrder(activeItem)"
                                >
                                    撤回实施人员
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="activeItem.processing_status === 0 && activeItem.is_processing_user && (activeItem.status > 0 && activeItem.status < 6)"
                                    @click="handleClickStartWorkOrder(activeItem)"
                                >
                                    出发
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="activeItem.processing_status === 1 && activeItem.is_processing_user && (activeItem.status > 0 && activeItem.status < 6)"
                                    @click="handleClickWorkOrderImplementStart(activeItem)"
                                >
                                    实施开始
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.processing_status === 0 || activeItem.processing_status === 1) &&
                                        workOrderSetForm &&
                                        workOrderSetForm.is_transfer === 1 &&
                                        activeItem.is_processing_user &&
                                        (activeItem.status > 0 && activeItem.status < 6)
                                    "
                                    @click="handleClickTransferWorkOrder(activeItem)"
                                >
                                    转单
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="activeItem.processing_status === 2 && activeItem.is_processing_user"
                                    @click="handleClickWorkOrderDailyWork(activeItem)"
                                >
                                    每日工作填写
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="activeItem.processing_status === 2 && activeItem.is_processing_user"
                                    @click="handleClickWorkOrderImplementEnd(activeItem)"
                                >
                                    实施结束
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        activeItem.processing_status === 3 &&
                                        activeItem.mode === 2 &&
                                        activeItem.is_processing_user &&
                                        activeItem.status < 6
                                    "
                                    @click="handleClickEndWorkOrder(activeItem)"
                                >
                                    结单
                                </li>
                                <li
                                    class="radio_option_item"
                                    v-if="
                                        (activeItem.status === 5 &&
                                            workOrderSetForm.is_evaluate == 1 &&
                                            activeItem.mode === 1 &&
                                            activeItem.is_assign_user) ||
                                        (activeItem.status === 6 &&
                                            workOrderSetForm.is_evaluate == 1 &&
                                            activeItem.mode === 2 &&
                                            activeItem.is_assign_user)
                                    "
                                    @click="handleClickEvaluateWorkOrder(activeItem)"
                                >
                                    评价
                                </li>
                            </ul>
                            <div class="cancel_btn" @click="handleRadioPicker = false">取消</div>
                        </div>
                    </van-overlay>
                </div>
            </template>
        </PullContainer>
        <WorkOrderAssign
            v-if="workOrderAssignPopupShow"
            :workOrderAssignPopupShow.sync="workOrderAssignPopupShow"
            :workorder_id="workorder_id"
            :processing_users_selected_ids="processing_users_selected_ids"
            @AssignSuccess="initData"
        />
        <WorkOrderProcessingUserReplace
            v-if="workOrderUserReplacePopupShow"
            :workOrderUserReplacePopupShow.sync="workOrderUserReplacePopupShow"
            :workorder_id="workorder_id"
            :processingUserSelectedList="processingUserSelectedList"
            @replaceSuccess="initData"
        />

        <WorkOrderProcessingUserRevoke
            v-if="workOrderUserRevokePopupShow"
            :workOrderUserRevokePopupShow.sync="workOrderUserRevokePopupShow"
            :workorder_id="workorder_id"
            :processingUserSelectedList="processingUserSelectedList"
            @revokeSuccess="initData"
        />
        <WorkOrderEvaluate
            v-if="workOrderEvaluatePopupShow"
            :workOrderEvaluatePopupShow.sync="workOrderEvaluatePopupShow"
            :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            :processingUserSelectedList="processingUserSelectedList"
            @evaluateSuccess="initData"
        />
        <WorkOrderFeedBackFinish
            v-if="workOrderFeedBackFinishPopupShow"
            :workOrderFeedBackFinishPopupShow.sync="workOrderFeedBackFinishPopupShow"
             :workorder_id="workorder_id"
            :workorder_num="workorder_num"
            @feedBackFinishSuccess="initData"
        />

    </div>
</template>
<script>
import {
    getFormFields,
    workOrderList,
    workOrderFeedbackStart,
    workOrderSetDetail,
    workOrderClose,
    workOrderDel,
    workOrderFeedbackEnd,
    workOrderNum,
    workOrderRevoke,
} from "@/api";
import { pagination } from "@/mixins";
import { mapState } from "vuex";
import { Dialog } from "vant";
import { EventBus } from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import userDetailDialog from "@/components/mComponents/userDetailDialog";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import WorkOrderAssign from "./work_order_assign.vue";
import WorkOrderProcessingUserReplace from "./work_order_processing_user_replace.vue";
import WorkOrderProcessingUserRevoke from "./work_order_processing_user_revoke.vue";
import WorkOrderEvaluate from "./work_order_evaluate.vue";
import WorkOrderFeedBackFinish from "./work_order_feedback_finish.vue";
export default {
    name: "WorkOrder",
    components: {
        userDetailDialog,
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        ListAdvancedFiltering,
        WorkOrderAssign,
        WorkOrderProcessingUserReplace,
        WorkOrderProcessingUserRevoke,
        WorkOrderEvaluate,
        WorkOrderFeedBackFinish
    },
    mixins: [pagination],
    data() {
        return {
            defaultImg: require("@/assets/images/default.jpg"),
            searchForm: {
                keyword: "",
            },
            workOrderTableList: [],
            loading: false, //加载动画

            workOrderTypeList: [
                {
                    label: "全部",
                    value: "all",
                    icon: "icon-gengduogongneng_weixuanzhong",
                    total: 0,
                },
                {
                    label: "我负责的",
                    value: "my_head",
                    icon: "icon-bumenfuzeren1",
                    total: 0,
                },
                {
                    label: "分配中心",
                    value: "assign",
                    icon: "icon-gongdan",
                    total: 0,
                },
                {
                    label: "我创建的",
                    value: "create",
                    icon: "icon-yiguanbi",
                    total: 0,
                },
                {
                    label: "进行中",
                    value: "processing",
                    icon: "icon-jinhangzhong",
                    total: 0,
                },
                {
                    label: "已完结",
                    value: "finish",
                    icon: "icon-yiwanjie",
                    total: 0,
                },
                {
                    label: "已关闭",
                    value: "close",
                    icon: "icon-a-yiguanbi1",
                    total: 0,
                },
            ],
            workOrderType: "all",

            // 获取工单后台配置
            workOrderSetForm: {},

            systemFilterFields: [], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件

            userDetailPopupShow: false,
            userDetailId: 0,

            handleRadioPicker: false,
            activeItem: {},


            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "WorkOrder",
                    title: "工单",
                },
                {
                    icon: "icon-zhuzhuangtu",
                    activeIcon: "icon-zhuzhuangtu",
                    routerName: "WorkOrderStatisticsReport",
                    title: "统计报表",
                },
                {
                    icon: "icon-rili",
                    activeIcon: "icon-rili",
                    routerName: "WorkOrderStatisticsCalendar",
                    title: "日历",
                },
                {
                    icon: "icon-gantetu",
                    activeIcon: "icon-gantetu",
                    routerName: "WorkOrderStatisticsGanttChart",
                    title: "甘特图",
                },
            ],
            tabBarActive: 0,
            workorder_id: "",
            workorder_num: "",
            processing_users_selected_ids: [],
            processingUserSelectedList: [],
            workOrderAssignPopupShow: false,
            workOrderUserReplacePopupShow: false,
            workOrderUserRevokePopupShow: false,
            workOrderEvaluatePopupShow: false,
            workOrderFeedBackFinishPopupShow: false
        };
    },
    computed: {
        ...mapState(["searchPopupShow"]),
        ...mapState(["userInfo"]),
        owner_uid() {
            return this.userInfo && this.userInfo.user && this.userInfo.user.id;
        },
    },
    created() {
        EventBus.$on('workOrderAddUpdated', this.initData);
        this.getWorkOrderSetDetail();
        this.initData();
    },
    mounted() {},
    methods: {
        pullDownLoadingSuccess(flag) {
            if (flag) {
                this.pullDownLoading = true;
                this.onSearch();
            }
        },
        // 类型切换
        handleClickTypeChange(item) {
            this.workOrderType = item.value;
            this.onSearch();
        },
        onSearch() {
            this.pagination.pageNum = 1;
            this.workOrderTableList = [];
            this.getWorkOrderTableList();
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.onSearch();
        },
        // 获取工单后台配置
        getWorkOrderSetDetail() {
            workOrderSetDetail().then((res) => {
                this.workOrderSetForm = res.data || {};
            });
        },
        // 初始化数据
        initData() {
            this.pagination.pageNum = 1;
            this.workOrderTableList = [];
            this.getWorkOrderNum();
            this.getWorkOrderTableList();
        },
        // 获取数量
        getWorkOrderNum() {
            workOrderNum().then((res) => {
                if (res.code === 200) {
                    const data = res.data || {};
                    if (data) {
                        this.workOrderTypeList[1].total = data.my_head_count || 0;
                        this.workOrderTypeList[2].total = data.assign_count || 0;
                        // this.workOrderTypeList[3].total = data.create_count || 0;
                        this.workOrderTypeList[4].total = data.processing_count || 0;
                        // this.workOrderTypeList[5].total = data.finish_count || 0;
                        // this.workOrderTypeList[6].total = data.close_count || 0;
                    }
                }
            });
        },
        // 加载更多
        onLoadList() {
            if (this.pagination.total == this.workOrderTableList.length) {
                return false;
            }
            if (this.loading == false) {
                this.getWorkOrderTableList();
            }
        },
        // 获取工单列表
        getWorkOrderTableList() {
            this.loading = true;
            workOrderList({
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
                keyword: this.searchForm.keyword,
                tab: this.workOrderType,
                custom_filter: this.custom_filter,
            }).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.workOrderTableList = this.workOrderTableList.concat(data || []);
                    this.pagination.pageNum++;
                    this.pagination.total = total;
                    this.loading = false;
                    // tableDataFieldShow(this.formInfoList, this.workOrderTableList);
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                }
                this.loading = false;
            });
        },

        // 人员详细信息
        handleClickUserInfo(info) {
            this.userDetailId = info.id;
            this.userDetailPopupShow = true;
        },
        //新建工单
        handleClickAddWorkOrder() {
            this.$router.push({
                name: "WorkOrderAdd",
            });
        },
        // 点击每条数据的三个点
        handleClickItem(row) {
            this.activeItem = JSON.parse(JSON.stringify(row));
            this.handleRadioPicker = true;
        },
        //删除工单
        handleClickDelWorkOrder(row) {
            Dialog.confirm({
                title: "删除工单",
                message: "确定要删除所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(228, 65, 68, 1)",
                confirmButtonText: "确定",
            }).then(() => {});
        },
        //工单详情
        handleClickWorkOrderDetail(row) {
            this.$router.push({
                name: "WorkOrderDetail",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                    name: row.workorder_num,
                },
            });
        },
        //撤销工单
        handleClickRevokeWorkOrder(row) {
            Dialog.confirm({
                title: "撤销工单",
                message: "确定要撤销所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "撤销",
            }).then(() => {});
        },
        // 关闭工单
        handleClickCloseWorkOrder(row) {
            Dialog.confirm({
                title: "关闭工单",
                message: "确定要关闭所选工单吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "确定",
            }).then(() => {
                workOrderClose({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                    if (res.code === 200) {
                        this.$toast(res.message);
                        this.initData();
                    }
                });
            });
        },
        //再次发起工单
        handleClickRestartWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderAddAgain",
                params: {
                    isPush: true,
                },
                query: {
                    work_order_id: row.id,
                },
            });
        },
        //分配实施人员
        handleClickDistributeWorkOrder(row) {
            this.workorder_id = row.id;
            this.processing_user_ids = (row.processing_users || []).filter(user=> user.status !== 3).map((item) => {
                    return item.processing_user;
                })
                .map((item) => item.id);
            this.workOrderAssignPopupShow = true;
        },
        //替换实施人员
        handleClickReplaceWorkOrder(row) {
            this.workorder_id = row.id;
            this.processingUserSelectedList = (row.processing_users || []).map((item) => {
                return item.processing_user;
            });
            this.workOrderUserReplacePopupShow = true;
        },
        //撤回实施人员
        handleClickRevokeDistributeWorkOrder(row) {
            this.workorder_id = row.id;
            this.processingUserSelectedList = (row.processing_users || []).filter(item=> item.status !== 3).map((item) => {
                return item.processing_user;
            })
            this.workOrderUserRevokePopupShow = true;
        },
        //工单出发
        handleClickStartWorkOrder(row) {
            if(row.processing_approval_id && row.processing_approval_status === 0) return this.$toast("您已发起工单出发申请，请等待审批通过!")
            this.$router.push({
                name: "WorkOrderTravel",
                query: {
                    id: row.id,
                    workorder_num: row.workorder_num,
                    assign_id: row.assign_id || 0,
                    travelInfo: {
                        project_id: row.project_id.value,
                        project_name: row.project_id.text,
                        order_id: row.order_id.value,
                        order_num: row.order_id.text,
                    },
                },
            });
        },
        //工单实施开始
        handleClickWorkOrderImplementStart(row) {
            Dialog.confirm({
                title: "实施开始",
                message: "确定现在已到达现场并开始实施吗？",
                className: "my_dialog",
                confirmButtonColor: "rgba(41, 144, 255, 1)",
                confirmButtonText: "确定",
            }).then(() => {
                const params = {
                    workorder_id: row.id,
                    workorder_num: row.workorder_num,
                    processing_uid: this.owner_uid,
                    processing_name: this.userInfo && this.userInfo.user && this.userInfo.user.name,
                };
                workOrderFeedbackStart(params).then((res) => {
                    if (res.code === 200) {
                        this.$toast(res.message);
                        this.initData();
                    }
                });
            });
        },
        //工单转单
        handleClickTransferWorkOrder(row) {
            this.$router.push({
                name: "WorkOrderTransfer",
                query: {
                    id: row.id,
                    processing_user_ids: (row.processing_users || [])
                        .map((item) => {
                            return item.processing_user;
                        })
                        .map((item) => item.id),
                },
            });
        },
        //工单每日工作填写
        handleClickWorkOrderDailyWork(row) {
            this.$router.push({
                name: "WorkOrderFeedBack",
                query: {
                    id: row.id,
                },
            });
        },
        //工单实施结束
        handleClickWorkOrderImplementEnd(row) {
            // 1=极简模式,2=简约工程模式
            const mode = row.mode;
            if (mode === 1) {
                Dialog.confirm({
                    title: "实施结束",
                    message: "确定现在已完成实施了吗？",
                    className: "my_dialog",
                    confirmButtonColor: "rgba(41, 144, 255, 1)",
                    confirmButtonText: "确定",
                }).then(() => {
                    workOrderFeedbackEnd({ workorder_id: row.id, workorder_num: row.workorder_num }).then((res) => {
                        if (res.code === 200) {
                            this.$toast(res.message);
                            this.initData();
                        }
                    });
                });
            } else {
                this.workorder_id = row.id;
                this.workorder_num = row.workorder_num;
                this.workOrderFeedBackFinishPopupShow = true;
            }
        },
        //工单结单
        handleClickEndWorkOrder(row) {
            const isAllFinish = row.processing_users.every((user) => user.status === 3);
            if (isAllFinish) {
                this.$router.push({
                    name: "WorkOrderFinish",
                    query: {
                        id: row.id,
                        workorder_num: row.workorder_num,
                        finishInfo: {
                            project_id: row.project_id.value,
                            project_name: row.project_id.text,
                            order_id: row.order_id.value,
                            order_num: row.order_id.text,
                        },
                    },
                });
            } else {
                this.$toast("全部实施人实施完成后才可以结单");
            }
        },
        //工单评价
        handleClickEvaluateWorkOrder(row) {
            this.workorder_id = row.id;
            this.workorder_num = row.workorder_num;
            this.processingUserSelectedList = (row.processing_users || []).map((item) => {
                return item.processing_user;
            });
            this.workOrderEvaluatePopupShow = true;
        }
    },
    beforeDestroy() {
        EventBus.$off('workOrderAddUpdated', this.initData);
    },
};
</script>
<style lang="scss" scoped>
@import "@/styles/m_style/work_order.scss";
</style>
